module.exports = __webpack_public_path__ + "img/Sylius-ecommerce.f28929fe.png";